/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var RotateSquareRightIcon24Solid = forwardRef('RotateSquareRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.362.292a1.125 1.125 0 0 0-1.424 1.741l.723.592H6.75A5.125 5.125 0 0 0 1.625 7.75V11a1.125 1.125 0 1 0 2.25 0V7.75A2.875 2.875 0 0 1 6.75 4.875h2.91l-.722.592a1.125 1.125 0 1 0 1.424 1.741l2.217-1.813a2.125 2.125 0 0 0 0-3.29L10.362.292Z" }),
        React.createElement("path", { d: "M6 13a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4h-6a4 4 0 0 1-4-4v-6Z" })));
});
